var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1914_4029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 4.77431V21.6C20.9999 22.9255 19.9254 24 18.5999 24H5.4C4.07452 24 3 22.9255 3 21.6V2.4C3 1.07452 4.07452 0 5.4 0H15.802L20.9999 4.77431Z",
    fill: "url(#paint0_linear_1914_4029)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1914_4029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 4.77431H16.4018C16.0704 4.77431 15.8018 4.50568 15.8018 4.17431V0L20.9996 4.77431Z",
    fill: "#FECDCA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.91366 19.3994V14.4994H7.74766C8.14433 14.4994 8.47333 14.5671 8.73466 14.7024C8.996 14.8377 9.18966 15.0197 9.31566 15.2484C9.44166 15.4771 9.50466 15.7384 9.50466 16.0324C9.50466 16.3031 9.444 16.5527 9.32266 16.7814C9.20133 17.0101 9.01 17.1967 8.74866 17.3414C8.48733 17.4814 8.15366 17.5514 7.74766 17.5514H6.85866V19.3994H5.91366ZM6.85866 16.7884H7.69166C7.995 16.7884 8.212 16.7207 8.34266 16.5854C8.478 16.4454 8.54566 16.2611 8.54566 16.0324C8.54566 15.7897 8.478 15.6031 8.34266 15.4724C8.212 15.3371 7.995 15.2694 7.69166 15.2694H6.85866V16.7884ZM10.2135 19.3994V14.4994H11.8515C12.4208 14.4994 12.8898 14.6021 13.2585 14.8074C13.6318 15.0081 13.9071 15.2927 14.0845 15.6614C14.2665 16.0254 14.3575 16.4547 14.3575 16.9494C14.3575 17.4441 14.2665 17.8757 14.0845 18.2444C13.9071 18.6084 13.6341 18.8931 13.2655 19.0984C12.8968 19.2991 12.4255 19.3994 11.8515 19.3994H10.2135ZM11.1585 18.5874H11.8025C12.2038 18.5874 12.5188 18.5221 12.7475 18.3914C12.9808 18.2607 13.1465 18.0741 13.2445 17.8314C13.3425 17.5841 13.3915 17.2901 13.3915 16.9494C13.3915 16.6041 13.3425 16.3101 13.2445 16.0674C13.1465 15.8201 12.9808 15.6311 12.7475 15.5004C12.5188 15.3697 12.2038 15.3044 11.8025 15.3044H11.1585V18.5874ZM15.1627 19.3994V14.4994H18.3547V15.2624H16.1077V16.5714H17.9067V17.3134H16.1077V19.3994H15.1627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1914_4029",
    x: 14.0018,
    y: -0.6,
    width: 7.59824,
    height: 7.17441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1914_4029"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1914_4029",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1914_4029",
    x1: 18.5,
    y1: 1.5,
    x2: 3,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4336"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1914_4029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3696000273cf95b013d808578d0c4977.svg";
export { ForwardRef as ReactComponent };